export default "__VITE_ASSET__DrVxz4nT__"